import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../styles/global.css';
import { useParams, useNavigate } from 'react-router-dom';
import { WhatsApp, Mail, MailOutline } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import { Button, CircularProgress } from '@mui/material'

function EnviarDocumento() {
    const { IdDocumento } = useParams();
    const navigate = useNavigate();
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [documento, setDocumento] = useState(null);
    const [pessoas, setPessoas] = useState([]);
    const [pessoasSelecionadas, setPessoasSelecionadas] = useState([]);
    const todasSelecionadas = pessoas.length > 0 && pessoasSelecionadas.length === pessoas.length;
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingSendEmail, setIsLoadingSendEmail] = useState(false);
    const [isLoadingSendWhats, setIsLoadingSendWhats] = useState(false);
    const loggedIn = sessionStorage.getItem('loggedIn');
    //envia para login se o usuário não estiver logado
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);

    //carrega o documento ao montar o componente
    useEffect(() => {
        const dados = {
            IdDocumento: IdDocumento
        };
        axios.post(`${process.env.REACT_APP_API_URL}/routes.php?metodo=obtemDocumento`
            , dados, {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'X-Access-Token': tokenAPI
                }
            } )
            .then(response => {
                if (response.data) {
                    setDocumento(response.data);
                }
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Erro ao buscar documento:', error);
                setIsLoading(false);
            });
    }, [IdDocumento]);

    //carrega as pessoas ao montar o componente
    useEffect(() => {
        const dados = {};
        axios.get(`${process.env.REACT_APP_API_URL}/routes.php?metodo=obterAssociadosAtivos`
            ,{
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'X-Access-Token': tokenAPI
                }
            } )
            .then(response => {
                if (response.data) {
                    setPessoas(response.data);
                }
            })
            .catch(error => {
                console.error('Erro ao buscar pessoas:', error);
            });
    }, []);
    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    //seleciona ou desmarca todas as pessoas
    function handleSelecionarTodas() {
        if (pessoas.length > 0 && pessoasSelecionadas.length === pessoas.length) {
            setPessoasSelecionadas([]);
        } else {
            setPessoasSelecionadas([...pessoas]);
        }
    }
    //seleciona ou desmarca uma pessoa individualmente
    const handleSelecionarPessoa = (pessoa) => {
        setPessoasSelecionadas(prevState => {
            const isSelected = prevState.some(p => p.IdPessoa === pessoa.IdPessoa);
            if (isSelected) {
                return prevState.filter(p => p.IdPessoa !== pessoa.IdPessoa);
            } else {
                return [...prevState, pessoa];
            }
        });
    };

    //recebe o nome e formata, devolve em string
    const formatarNome = (nome) => {
        let nomeFormatado = '';
            const arrayNome = nome.trim().split(' ');
            if (arrayNome.length < 3) {
                nomeFormatado = nome; 
            } else {
                nomeFormatado = arrayNome[0];
                
                for (let i = 1; i < arrayNome.length - 1; i++) {
                    if (arrayNome[i].length > 2 
                        && i < arrayNome.length
                        && arrayNome[i].toUpperCase().trim() !== 'DOS'
                        && arrayNome[i].toUpperCase().trim() !== 'DA'
                        && arrayNome[i].toUpperCase().trim() !== 'DE'
                        && arrayNome[i].toUpperCase().trim() !== 'DO'
                        && arrayNome[i].toUpperCase().trim() !== 'DAS'
                        && arrayNome[i].toUpperCase().trim() !== 'DOS') {
                        nomeFormatado += ' ' + arrayNome[i].charAt(0) + '.';
                    } else {
                        nomeFormatado += ' ' + arrayNome[i];
                    }
                }
                nomeFormatado += ' ' + arrayNome[arrayNome.length - 1];
            }
        return nomeFormatado;
    };

    const enviarEmailIndividual = async (pessoa) => {
        try {
            if (documento && documento.docMensagem && documento.docMensagem.trim() !== '') {
                if (!window.confirm(`Deseja enviar um email para ${formatarNome(pessoa.pesNome)}?`)) {
                    return;
                }
                await enviarEmailSelecionado(pessoa);
                //alert(`Email enviado para ${pessoa.pesNome}`);
            } else {
                alert('A mensagem não pode estar vazia.');
            }
        } catch (error) {
            alert(`Erro ao enviar email para ${formatarNome(pessoa.pesNome)}: ${error.message}`);
        }
    };

    const enviarEmailSelecionado = async (pessoa) => {
        try {
            // lógica para comunicar cada selecionado
            var corpoEmail = `
            <div style="margin: 0px; width: 100vw; height: 100vh; color: white; background-color: black; font-family: Arial, Helvetica, sans-serif;">
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <img width="200px" src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="logoMGBE"/>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        Caro ${pessoa.pesNome},
                        <br />
                        <br/>
                        Título: ${documento.docDescricao ? documento.docDescricao : ''}
                        <br /><br />
                        ${documento.docObservacoes ? documento.docObservacoes : ''}
                        <br />
                        <br />
                        ${documento.docMensagem ? documento.docMensagem : ''}
                        <br />
                        <br />
                        <b><a href="https://www.brasilextremos.com.br/api/${documento.docCaminho}">CLIQUE AQUI PARA VER O DOCUMENTO</a></b>
                        <br />
                        <br />
                    </div>
                </div>
                <hr />
                <div style="font-size: 12px; color: #c1bbbb; padding: 10px;">
                    O conteúdo desse e-mail é destinado apenas ao destinatário.<br />
                    Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                    A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                    Agradecemos sua compreensão e cooperação.<br />
                    <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                </div>
            </div>
            `;
            const dadosEmail = {
                "email": pessoa.pesEmail,
                "assunto": 'MGBE - Documento: ' + (documento.docDescricao ? documento.docDescricao : ''),
                "mensagem": corpoEmail
            };
            
            //console.log('Dados do email a serem enviados para ' + pessoa.pesEmail);
            axios
            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                dadosEmail,
                {
                    headers: 
                    {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            )
            .then(response => {
                console.log('Resposta do envio de email para ' + pessoa.pesEmail + ':', response.data);
                if (response.data.message === 'E-mail enviado com sucesso!') {
                    console.log('Email enviado para ' + pessoa.pesEmail + " com sucesso!\n" + response.data.message);
                    salvarLog('Email enviado para ' + pessoa.pesEmail + " com sucesso!\n" + response.data.message);
                } else {
                    console.log('Erro ao enviar email para ' + pessoa.pesEmail + "!\n" + response.data.message);
                    salvarLog('Erro ao enviar email para ' + pessoa.pesEmail + "!\n" + response.data.message);
                }
            })
            .catch(error => {
                alert(`Houve um erro ao enviar o email`);
                salvarLog('Houve um erro ao enviar o email para ' + pessoa.pesEmail + "!\n" + error);
            });
        } catch (error) {
            alert('Erro ao enviar email para o pessoa: ' + error.message);
        }
    };

    const enviarWhatsAppSelecionado = (pessoa) => {
        try {
            const nomeFormatado = formatarNome(pessoa.pesNome);
            const celularFormatado = `+55${pessoa.pesCelular.replace(' ', '').replace('-', '').replace('(', '').replace(')', '')}`;
            const texto = `Olá, ${nomeFormatado}.\n\n Você está recebendo um link para acessar o documento:\n${documento.docDescricao}.\n\n${documento.docMensagem.replace(/<br \/>/g, '\n')}\n\n${`https://www.brasilextremos.com.br/api/${documento.docCaminho}`}\n\nEsse documento é Oficial e Restrito. \nProibido compartilhar com pessoas que não sejam associados!\n\nGestão MGBE.`;
            //console.log('Enviando mensagem via WhatsApp para ' + pessoa.pesNome + ' no número ' + celularFormatado); return;
            window.open(`https://wa.me/${celularFormatado}?text=${encodeURIComponent(texto)}`, '_blank');
        } catch (error) {
            alert('Erro ao enviar mensagem via WhatsApp para o associado: ' + error.message);
        }
    };

    const enviarWhatsAppIndividual = (pessoa) => {
        if (documento && documento.docMensagem && documento.docMensagem.trim() !== '') {
            const nomeFormatado = formatarNome(pessoa.pesNome);
            if (window.confirm(`Deseja enviar a mensagem via WhatsApp para ${nomeFormatado}?`)) {
                enviarWhatsAppSelecionado(pessoa);
            }
        } else {
            alert('A mensagem não pode estar vazia.');
            return;
        }
    };

    function handleSalvarMensagem() {
        //salvar o documento atual
        salvarLog('Mensagem salva para o documento: ' + documento.docDescricao);
        if (documento && documento.IdDocumento > 0) {
            axios
            .post(process.env.REACT_APP_API_URL +
                '/routes.php?metodo=atualizarDocumento', documento, {
                    headers: {
                        'X-Access-Token': tokenAPI,
                        'Content-Type': 'application/json; charset=UTF-8'
                    }
                }
            )
            .then(response=> {
                alert(response.data['mensagem']);
                //window.location.href = '/#/Documentos'
            })
            .catch(error => {
                console.error('Houve um erro ao enviar o formulário:', error);
                alert('Houve um erro ao atualizar documento. Por favor, tente novamente.');
            });
        }
    }

    function salvarLog(logmensagem) {
        const log = {
        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        logTipo: `Enviar Documento - ${documento.docDescricao}`,
        logModulo: logmensagem,
        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
        logCriadoEm: new Date().toISOString(),
        logCodigoGUID: crypto.randomUUID()
        };
        axios                    
        .post(process.env.REACT_APP_API_URL 
            + '/routes.php?metodo=novoLog', 
            log, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            console.log(response.data[0].mensagem);
            //setSalvarLog(false);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error);
            //setSalvarLog(false);
        })
    }

    //volta para a página anterior
    function handleFecharModal() {
        window.history.back();
    }

    //console.log(documento);

    async function enviarEmailParaSelecionados() {
        setIsLoadingSendEmail(true);
        await new Promise(resolve => setTimeout(resolve, 2000)); // Simula uma espera assíncrona, substitua conforme necessário
        if (pessoasSelecionadas && pessoasSelecionadas.length > 0) {
            for (const pessoa of pessoasSelecionadas) {
                if (documento && documento.docMensagem && documento.docMensagem.trim() !== '') {
                    if(pessoa && pessoa.pesEmail && pessoa.pesEmail.trim() !== '') {
                        await new Promise(resolve => setTimeout(resolve, 3000)); // Simula uma espera assíncrona, substitua conforme necessário
                        await enviarEmailSelecionado(pessoa);
                    } else {
                        console.log(`O email de ${pessoa.pesNome.split(' ')[0]} não está disponível.`);
                    }
                } else {
                    alert('A mensagem não pode estar vazia.');
                    return;
                }
            }
            setIsLoadingSendEmail(false);
        } else {
            alert('Nenhuma pessoa selecionada.');
            setIsLoadingSendEmail(false);
        }
    }

    async function enviarWhatsAppParaSelecionados() {
        setIsLoadingSendWhats(true);
        await new Promise(resolve => setTimeout(resolve, 2000)); // Simula uma espera assíncrona, substitua conforme necessário
        if (pessoasSelecionadas && pessoasSelecionadas.length > 0) {
            for (const pessoa of pessoasSelecionadas) {
                if (documento && documento.docMensagem && documento.docMensagem.trim() !== '') {
                    if(pessoa && pessoa.pesCelular && pessoa.pesCelular.trim() !== '') {
                        await new Promise(resolve => setTimeout(resolve, 5000)); // Simula uma espera assíncrona, substitua conforme necessário
                        if (window.confirm(`Deseja enviar a mensagem para o WhatsApp de ${pessoa.pesNome.split(' ')[0]}, ${pessoa.pesCelular}?`)) {
                            enviarWhatsAppSelecionado(pessoa);
                            console.log(`Mensagem enviada para o WhatsApp de ${pessoa.pesNome}`);
                        }
                    } else {
                        console.log(`O número de WhatsApp de ${pessoa.pesNome.split(' ')[0]} não está disponível.`);
                    }
                } else {
                    alert('A mensagem não pode estar vazia.');
                    return;
                }
            }
            setIsLoadingSendWhats(false);
        } else {
            alert('Nenhuma pessoa selecionada.');
            setIsLoadingSendWhats(false);
        }
        
    }

    //console.log(`Documento: `, documento);

    return (
        <div>
            <main style={{ paddingBottom: '80px' }}>
                {isLoading ? (
                    <CircularProgress />
                ) : (
                    <div>
                        {/* fechar */}
                        <div className='d-flex w100 mt1 flex-column text-align-center'>
                            <div className='text-align-center w100 fs16'>
                                <button
                                    className="buttonModalVoltarLaranja fs11"
                                    onClick={handleFecharModal}>Fechar
                                </button>
                            </div>
                        </div>

                        {documento ? (
                            <div>
                                <div className="headerMain">
                                    <label className='labelTitulo' >ENVIAR DOCUMENTO</label>
                                </div>
                                {windowWidth < 768 ? (
                                    <div className="d-flex w100 flex-column tdAlignLeft pb4">
                                        <div className="text-align-left divForm fs11">
                                            <label className='labelTitulo'>Título</label>
                                            <div style={{ marginBottom: '16px', marginTop: '16px' }}><h1>{documento.docDescricao}</h1></div>
                                            <hr />
                                            <div style={{ marginBottom: '16px', marginTop: '16px' }}><label className='labelTitulo'>Descrição</label></div>
                                            <p>{documento.docObservacoes}</p>
                                            <hr style={{ marginBottom: '16px', marginTop: '16px' }} />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="d-flex w100 flex-column tdAlignLeft pb4">
                                        <div className="text-align-left divForm fs11">
                                            <label className='labelTitulo'>Título</label>
                                            <div style={{ marginBottom: '16px', marginTop: '16px' }}><h1>{documento.docDescricao}</h1></div>
                                            <hr />
                                            <div style={{ marginBottom: '16px', marginTop: '16px' }}><label className='labelTitulo'>Descrição</label></div>
                                            <p>{documento.docObservacoes}</p>
                                            <hr style={{ marginBottom: '16px', marginTop: '16px' }} />
                                        </div>
                                    </div>
                                )}
                                <div className="d-flex flex-row text-align-center mb2">
                                    <div className={`${window.innerWidth < 768 ? 'w90' : 'w50'}`}>
                                        <div className="text-align-left divForm fs11">
                                            <label className='labelTitulo'>Mensagem</label>
                                        </div>
                                        <div className="text-align-left divForm w100 fs11 mt1">
                                            <textarea 
                                                value={documento.docMensagem.replace(/<br \/>/g, '\n')}
                                                onChange={(e) => setDocumento({...documento, docMensagem: e.target.value})}
                                                className="p1 fs12 w100 text-align-left" 
                                            />
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div>{documento.docMensagem ? documento.docMensagem.length : 0}/1024</div>
                                            <Button variant="contained" color="primary" onClick={handleSalvarMensagem}>
                                                Salvar Mensagem
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="text-align-center">
                                        <label className='labelTitulo'>Associados Ativos</label>
                                    </div>
                                    <div className="text-align-center mt1">
                                        <button 
                                            onClick={handleSelecionarTodas}
                                                    style={{
                                                    padding: '10px 20px',
                                                    marginBottom: '15px',
                                                    cursor: 'pointer',
                                                    backgroundColor: todasSelecionadas ? '#ffcdd2' : '#c8e6c9',
                                                    border: '1px solid #999',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold'
                                                    }}
                                                    >
                                                    {todasSelecionadas ? 'DESMARCAR TODAS' : 'SELECIONAR TODAS'}
                                        </button>
                                    </div>
                                    {pessoasSelecionadas.length > 0 && (
                                        <div className="text-align-center mt1">
                                            <label className='labelTitulo'>Associados Selecionados: {pessoasSelecionadas.length}</label>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                                                <div>
                                                    <button
                                                        onClick={() => enviarEmailParaSelecionados()}
                                                        disabled={isLoadingSendEmail}
                                                        style={{
                                                            margin: '5px',
                                                            padding: '5px 10px',
                                                            cursor: 'pointer',
                                                            backgroundColor: '#c8e6c9',
                                                            border: '1px solid #999',
                                                            borderRadius: '4px',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        {isLoadingSendEmail ? 'Enviando...' : 'Enviar email'}
                                                    </button>
                                                </div>
                                                    <button
                                                        onClick={() => enviarWhatsAppParaSelecionados()}
                                                        disabled={isLoadingSendWhats}
                                                        style={{
                                                            display: 'none',
                                                            margin: '5px',
                                                            padding: '5px 10px',
                                                            cursor: 'pointer',
                                                            backgroundColor: '#bbdefb',
                                                            border: '1px solid #999',
                                                            borderRadius: '4px',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        {isLoadingSendWhats ? 'Enviando...' : 'Enviar WhatsApp'}
                                                    </button>
                                                <div>
                                                </div>
                                            </div>
                                        </div>

                                    )}
                                    <div className="d-flex flex-row ">
                                        <div className={`d-flex flex-column divForm ${window.innerWidth < 768 ? 'w90' : 'w50'} fs09`} style={{ backgroundColor: '#cbc7c7', padding: '5px', borderRadius: '5px' }}>
                                            {pessoas ? 
                                                pessoas
                                                .filter(pessoa => {
                                                    if(parseInt(pessoa.pesStatus) === 1 
                                                    && parseInt(pessoa.pesAssociado) === 1
                                                    && pessoa.pesCelular
                                                    && pessoa.pesCelular.trim() !== ''
                                                ){
                                                        return pessoa;
                                                    }
                                                })
                                                .map(pessoa => {
                                                    const estaSelecionada = pessoasSelecionadas.some((p) => p.IdPessoa === pessoa.IdPessoa);
                                                    return (
                                                        <div key={pessoa.IdPessoa}
                                                            style={{ borderRadius: '5px', padding: '5px', cursor: 'pointer', width: '100%', backgroundColor: estaSelecionada ? '#507455' : '#5c5a5a' }} >
                                                            <div style={{ padding: '3px', textAlign: 'left', paddingTop: '5px' }}>
                                                                <p style={{ width: '100%' }} onClick={() => handleSelecionarPessoa(pessoa)}><b>{pessoa.pesNome}</b></p> 
                                                                {pessoa.pesEmail ? (
                                                                    <>
                                                                        <div onClick={() => handleSelecionarPessoa(pessoa)}>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.8em' }}>{pessoa.pesEmail.split('@')[0]}</span>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.7em' }}>@{pessoa.pesEmail.split('@')[1]}</span>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.9em' }}>{pessoa.pesCelular}</span>
                                                                        </div>
                                                                        <div style={{ display: !estaSelecionada ? 'none' : 'block', width: '97%', textAlign: 'center', borderRadius: '5px', paddingBottom: '5px', backgroundColor: '#f2eded', margin: '10px ', padding: '5px' }}>
                                                                            <label>
                                                                                {pessoa.pesEmail && estaSelecionada && (
                                                                                    <Tooltip title="Enviar email de convocação">
                                                                                        <label style={{ cursor: 'pointer', marginRight: '15px' }}>
                                                                                            <MailOutline style={{ color: '#a3a7e6', fontSize: '30px' }} onClick={() => enviarEmailIndividual(pessoa)} />
                                                                                        </label>
                                                                                    </Tooltip>
                                                                                )}
                                                                                {pessoa.pesCelular && estaSelecionada && (
                                                                                    <Tooltip title="Enviar mensagem via WhatsApp">
                                                                                        <label style={{ cursor: 'pointer', marginRight: '15px' }}>
                                                                                            <WhatsApp style={{ color: '#25D366', fontSize: '30px', }} onClick={() => enviarWhatsAppIndividual(pessoa)} />
                                                                                        </label>
                                                                                    </Tooltip>
                                                                                )}
                                                                            </label>
                                                                        </div>
                                                                    </>
                                                                ) : ''}
                                                            </div>
                                                            <div style={{ width: '100%', textAlign: 'right', paddingBottom: '5px' }}>
                                                                {estaSelecionada && <span> (Selecionada)</span>}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                : <p>Nenhuma pessoa encontrada.</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <p>Documento não encontrado.</p>
                        )}
                    </div>
                )}
            </main>
        </div>
    );
}

export default EnviarDocumento;